import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '@/config/api';

const API = API_BASE_URL;

export default function useDashboard(options = {}) {
  const {
    autoFetch = true,
    period = 'last_7_days',
    startDate,
    endDate,
    restaurantId,
  } = options;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(autoFetch);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const params = { period };
      if (period === 'custom') {
        if (startDate) {
          params.start_date = startDate;
        }
        if (endDate) {
          params.end_date = endDate;
        }
      }
      if (restaurantId) {
        params.restaurant_id = restaurantId;
      }

      const response = await axios.get(`${API}/dashboard`, {
        withCredentials: true,
        params,
      });

      setData(response.data);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [period, startDate, endDate, restaurantId]);

  useEffect(() => {
    if (!autoFetch) {
      return;
    }
    fetchDashboard().catch(() => {
      // Error is captured in state for consumers.
    });
  }, [autoFetch, fetchDashboard]);

  return {
    data,
    loading,
    error,
    refetch: fetchDashboard,
  };
}
